import { AHIcon, Box, Circle, ListItem } from "arkh";
import React, { ReactNode } from "react";
import { ActivityIndicator } from "react-native";

import { IntegrationLogo, IntegrationLogoType } from "./Logos/Logos";

type MODE = "ADD" | "positive" | "semiNegative" | "negative" | "loading";

export const IntegrationLogoItem = (props: {
  onPress(): void;
  isFirst?: boolean;
  isLast?: boolean;
  right?: ReactNode;
  logoType: IntegrationLogoType;
  mode: MODE;
}) => {
  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      border="border-primary"
      onPress={props.onPress}
      right={<ModeRenderer mode={props.mode} />}
    >
      <Box
        style={{
          flex: 1,
          flexDirection: "row",
          minHeight: 20,
          maxWidth: 75,
        }}
      >
        <IntegrationLogo type={props.logoType} />
      </Box>
    </ListItem>
  );
};
export const IntegrationTextItem = (props: {
  onPress(): void;
  isFirst?: boolean;
  isLast?: boolean;
  children: ReactNode;
  mode: MODE;
}) => {
  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      border="border-primary"
      onPress={props.onPress}
      right={<ModeRenderer mode={props.mode} />}
    >
      <ListItem.Title>{props.children}</ListItem.Title>
    </ListItem>
  );
};

function ModeRenderer(props: { mode: MODE }) {
  if (props.mode === "ADD") {
    return <AHIcon type="add" />;
  }
  if (props.mode === "loading") {
    return <ActivityIndicator size="small" color="#000" />;
  }

  return (
    <Circle
      size="badge"
      color={
        props.mode === "positive"
          ? "status-positive"
          : props.mode === "semiNegative"
            ? "status-semiNegative"
            : "status-negative"
      }
    />
  );
}
